<script lang="ts" setup>
import { useAuth } from "@/composables/useAuth";
import useHasPermissionUser from "@/composables/useHasPermissionUser";

interface Props {
  namePermission: string;
  entityType: string;
}

defineProps<Props>();

const { hasPermissionUser } = useHasPermissionUser();
</script>

<template>
  <div v-if="hasPermissionUser(namePermission, entityType)">
    <slot />
  </div>
</template>
